import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    call_date: '',
    caller: '',
    work_start_date: '',
    emergency_type: {},
    close_date: '',
    is_emergency_line: null,
    emergency_info: '',
    emergency_location: '',
    line_facility_owner: '',
    minor_injury_count: 0,
    severe_injury_count: 0,
    fatal_injury_count: 0,
    evacuated_people_count: 0,
    provided_medical_count: 0,
    work_scope: '',
    situation_during_filing: '',
    transport: [],
    client_equipment_count: 0,
    branch_worker_count: 0,
    worker_man_hours: 0,
    third_parties_count: 0,
    other_info: '',
    // status: 'idle',
    error: null
};

export const sendReport = createAsyncThunk(
    'send/sendReport',
    async({reportData, token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const body = {
                data: {
                    type: "report",
                    attributes: reportData
                }
            }

            const response = await request(
                `${APP_URL}/reports`,
                'POST',
                body,
                customHeaders
            );

            return response;
        } catch (error) {
            console.log("Error in sending departure", error);
            return rejectWithValue(error);
        }
    }
);

export const sendUpdate = createAsyncThunk(
    'send/sendUpdate',
    async({reportData, token, departureId}, {rejectWithValue, getState}) => {

        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const body = {
                data: {
                    type: "update",
                    attributes: reportData
                }
            }

            const response = await request(
                `${APP_URL}/reports/update/${departureId}`,
                'POST',
                body,
                customHeaders
            );


            return response;
        } catch (error) {
            console.log("Error in sending departure", error);
            return rejectWithValue(error);
        }
    }
);

export const sendFeedback = createAsyncThunk(
    'send/sendFeedback',
    async({credentials, token}, {rejectWithValue, getState}) => {

        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const body = {
                title: credentials.title,
                feedback: credentials.feedback
            }

            const response = await request(
                `${APP_URL}/send-feedback`,
                'POST',
                body,
                customHeaders
            );


            return response;
        } catch (error) {
            console.log("Error in sending feedback", error);
            return rejectWithValue(error);
        }
    }
);

const sendSlice = createSlice({
    name: 'send',
    initialState,
    reducers: {
        addTransport: (state, action) => {
            const { id, name } = action.payload;

            state.transport.push({ id, name, count: 1 });
            state.errorMessage = null;
        },
        removeTransport: (state, action) => {
            state.transport = state.transport.filter(
                (transport) => transport.id !== action.payload
            );
        },
        updateTransportQuantity: (state, action) => {
            const { id, count } = action.payload;
            const transport = state.transport.find(
                (transport) => transport.id === id
            );
            if (transport) {
                transport.count = count;
            }
        },
        addEmergency: (state, action) => {
            const { id, name } = action.payload;
            state.emergency_type = { id, name };
        },
        addOperationsType: (state, action) => {
            state.is_emergency_line = action.payload;
        },
        setFormField: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        resetForm: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(sendReport.fulfilled, (state) => {
                state.status = 'idle';
            })
            .addCase(sendReport.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.payload;
            })
            .addCase(sendUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(sendUpdate.fulfilled, (state) => {
                state.status = 'idle';
            })
            .addCase(sendUpdate.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.payload;
            })
            .addCase(sendFeedback.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(sendFeedback.fulfilled, (state) => {
                state.status = 'idle';
            })
            .addCase(sendFeedback.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.payload;
            })
    }
});

export const { addTransport, removeTransport, updateTransportQuantity, addEmergency, addOperationsType, setFormField, resetForm } = sendSlice.actions;
export default sendSlice.reducer;